// extracted by mini-css-extract-plugin
module.exports = {"base":"Pagination_base__YpNN6"};